export default __webpack_public_path__ + "static/media/insights-empty-welcome.fd077dae.svg";